import { i18n } from "services/i18nService";

export const SEND_FOR_SKU_OPTIONS = [
  { id: "ItemId", name: i18n("shipStation.sendForSku.ItemNumber") },
  { id: "SKU", name: i18n("shipStation.sendForSku.Sku") },
  { id: "Name", name: i18n("shipStation.sendForSku.ItemName") },
];

export const SEND_FOR_DESCRIPTION_OPTIONS = [
  { id: "Name", name: i18n("shipStation.sendForDescription.ItemName") },
  {
    id: "ItemDescription",
    name: i18n("shipStation.sendForDescription.ItemDescription"),
  },
  {
    id: "ShipmentDescription",
    name: i18n("shipStation.sendForDescription.ShipmentDescription"),
  },
];
